import { lazy } from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import CacheBuster from 'react-cache-buster';
import { ToastContainer } from 'react-toastify';

import { AppContextProvider } from '#/context';
import { useSentry, useSetupAxios } from '#/services';
import { version } from '../package.json';
const ChatbotWidget = lazy(() => import('./pages/chatbot/components/ChatbotWidget'));

function App() {
  const queryClient = new QueryClient();

  const isCacheBusterEnable = !!Number(import.meta.env.VITE_CACHE_BUSTER);

  useSetupAxios();
  useSentry();

  return (
    <QueryClientProvider client={queryClient}>
      <AppContextProvider>
        <CacheBuster currentVersion={version} isEnabled={isCacheBusterEnable} metaFileDirectory={'/inpage-chatbot-widget'}>
          <ChatbotWidget />
        </CacheBuster>
      </AppContextProvider>
      <ToastContainer />
    </QueryClientProvider>
  );
}

export default App;
